import React, { useEffect } from 'react';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound from '@/components/ui/tables/IsLoadingNotFound';

const DataTable = ({ isLoading, tableColumn, dataSource, totalRecord, dataFilter, onChangePage }) => {
    useEffect(() => {
        console.log({ 'data source': dataSource });
    }, [dataSource]);

    return (
        <TableWrapServerSide
            tableColumnList={tableColumn}
            totalDataCount={totalRecord}
            initialPage={dataFilter?.page}
            onChangePage={onChangePage}
            per_page={dataFilter?.limit}
        >
            {Array.isArray(dataSource) && dataSource.length > 0 ? (
                dataSource.map((data) => (
                    <tr className="db-table-body-tr" key={data._id}>
                        <td className="db-table-body-td">{data.name}</td>
                        <td className="db-table-body-td">{data?.category?.name ?? '—'}</td>
                        <td className="db-table-body-td">
                            {Number(data?.item_type) === 1 ? (
                                <span className="active">Veg</span>
                            ) : (
                                <span className="inactive">Non Veg</span>
                            )}
                        </td>
                        <td className="db-table-body-td">{data?.total_quantity_sold ?? 0}</td>
                    </tr>
                ))
            ) : (
                <IsLoadingNotFound isLoading={isLoading} colSpan={tableColumn.length} />
            )}
        </TableWrapServerSide>
    );
};

export default DataTable;
